jQuery(function($){
    $('form.variations_form').on('found_variation', function(event, variation) {
        if(variation.sku) {
            $('.product-sku').text(variation.sku);
        } else {
            // Fallback to parent SKU if variation has no SKU
            $('.product-sku').text(variation.product_sku || '');
        }
    });

    // Optional: reset SKU if no variation selected
    $('form.variations_form').on('reset_data', function() {
        var parentSku = $('.product-sku-wrapper').data('parent-sku');
        $('.product-sku').text(parentSku);
    });
});
